import { render, staticRenderFns } from "./TriageAnswerComponent.vue?vue&type=template&id=a298ecf2&scoped=true&"
import script from "./TriageAnswerComponent.vue?vue&type=script&lang=js&"
export * from "./TriageAnswerComponent.vue?vue&type=script&lang=js&"
import style0 from "./TriageAnswerComponent.vue?vue&type=style&index=0&id=a298ecf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a298ecf2",
  null
  
)

export default component.exports